import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getEyeListReportList } from 'models/optomeryReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

// import InpatientListInner from './Inner';

const routes: CustomRoute = {
	path: '/optometry-report',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inpatientList' */ './component')],
			render: ([OptomeryReport]) => <OptomeryReport />,
			onEnter: async ({ store, next }) => {
				console.log('on Optomery Report Page');
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.OPTOMERY_REPORT}`);
				if (allowEnter) {
					await store.dispatch(getEyeListReportList());
				}
				const children = await next();
				return children;
			},
		},
		// InpatientListInner,
	],
};
export default routes;
